import { render, staticRenderFns } from "./NextRaceCard.vue?vue&type=template&id=0d237730&scoped=true"
import script from "./NextRaceCard.vue?vue&type=script&lang=js"
export * from "./NextRaceCard.vue?vue&type=script&lang=js"
import style0 from "./NextRaceCard.vue?vue&type=style&index=0&id=0d237730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d237730",
  null
  
)

export default component.exports